;(function($, window) {
    $.plugin('teBanner', {
        defaults: {
            /**
             * Horizontal focus position
             *
             * @property value ( 0 - 100 )
             * @type {Integer}
             */
            focusX: 50,

            /**
             * Vertical focus position
             *
             * @property value ( 0 - 100 )
             * @type {Integer}
             */
            focusY: 15,

            /**
             * Class used for horizontal alignment
             *
             * @property alignClsX
             * @type {String}
             */
            alignClsX: 'align-x',

            /**
             * Class used for vertical alignment
             *
             * @property alignClsY
             * @type {String}
             */
            alignClsY: 'align-y',

            /**
             * Zoom amount used by zoom function.
             *
             * @property zoom
             * @type {Integer}
             */
            zoom: 1.2,

            /**
             * Transition time in seconds.
             *
             * @property transitionTime
             * @type {Integer}
             */
            transitionTime: 0,

            /**
             * Selects the banner inner element.
             *
             * @property innerSelector
             * @type {String}
             */
            innerSelector: '.banner-inner',

            /**
             * Selector of the image element
             *
             * @property imageSelector
             * @type {String}
             */
            imageSelector: 'img:first'
        },
        /**
         * Initializes the plugin and sets up the necessary event handler
         */
        init: function() {
            var me = this,
                opts = me.opts,
                $inner = me.$el.find(opts.innerSelector);
            me.applyDataAttributes();
            me.$img = me.$el.find(opts.imageSelector);
            me.$inner = $inner.length?$inner:me.$el;
            me.imgR = parseInt(me.$img.attr('width'))/parseInt(me.$img.attr('height'));
            me.container = {};
            me.$inner.css('transition-duration', me.opts.transitionTime+'s');
            me.setSizes();
            me.setImage();

            me.registerEvents();
        },

        registerEvents: function() {
            const me = this;
            me._on($(window), 'resize', $.proxy(me.onResize, me));
        },

        onResize: function() {
            this.setSizes();
            this.setImage();
        },

        setSizes:function() {
            var me = this;
            me.container.w = me.$el.width();
            me.container.h = me.$el.height();
            me.container.r = me.container.w / me.container.h;
        },

        setImage: function() {
            var me = this,
                cRatio = me.container.r,
                iRatio = me.imgR,
                $img = me.$img,
                origin = {},
                css = {},
                offset;

            switch (me.align) {
                case 'x':
                    if (cRatio > iRatio) {
                        origin.x = me.opts.focusX;
                        origin.y = me.convertFocus(me.align = 'y', offset = me.getTop());
                        css.top = '-'+offset+'%';
                        css.left = '';
                        $img.addClass('align-y').removeClass('align-x');
                    } else {
                        origin.x = me.convertFocus(me.align, offset = me.getLeft());
                        origin.y = me.opts.focusY;
                        css.left = '-'+offset+'%';
                    }
                    break;
                case 'y':
                    if (cRatio < iRatio) {
                        origin.x = me.convertFocus(me.align = 'x', offset = me.getLeft());
                        origin.y = me.opts.focusY;
                        css.top = '';
                        css.left = '-'+offset+'%';
                        $img.addClass('align-x').removeClass('align-y');
                    } else {
                        origin.x = me.opts.focusX;
                        origin.y = me.convertFocus(me.align, offset = me.getTop());
                        css.top = '-'+offset+'%';
                    }
                    break;
                default:
                    if (cRatio < iRatio) {
                        origin.x = me.convertFocus(me.align = 'x', offset = me.getLeft());
                        origin.y = me.opts.focusY;
                        css.left = '-'+offset+'%';
                        $img.addClass('align-x');
                    } else {
                        origin.x = me.opts.focusX;
                        origin.y = me.convertFocus(me.align = 'y', offset = me.getTop());
                        css.top = '-'+offset+'%';
                        $img.addClass('align-y');
                    }
            }
            $img.css(css);
            me.setOrigin(origin);
        },

        convertFocus: function(align, offset) {
            var me = this;
            switch (align) {
                case 'x':
                    return (((100/me.container.r)*me.imgR)*(me.opts.focusX/100))-offset;
                case 'y':
                    return (((100*me.container.r)/me.imgR)*(me.opts.focusY/100))-offset;
            }
        },

        setOrigin: function(origin) {
            var me = this;
            me.$inner.css('transform-origin', origin.x+'% '+origin.y+'%');
        },

        zoomIn: function() {
            var me = this;
            me.$inner.css('transform', 'scale('+me.opts.zoom+')');
        },

        zoomOut: function() {
            var me = this;
            me.$inner.css('transform', '');
        },

        reset: function() {
            var me = this;
            me.$inner.css('transition-duration', '0s');
            me.$inner.css('transform', '');
            setTimeout(function() {
                me.$inner.css('transition-duration', me.opts.transitionTime+'s');
            }, 10);
        },

        getTop: function() {
            var me = this,
                h = me.container.h;
            return ((me.container.w/me.imgR)-h)*me.opts.focusY/h;
        },

        getLeft: function() {
            var me = this,
                w = me.container.w;
            return ((me.container.h*me.imgR)-w)*me.opts.focusX/w;
        }
    });
})(jQuery, window);
